"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ticket = exports.TicketStatusEnum = void 0;
const typeorm_1 = require("typeorm");
const data_ui_1 = require("../data-ui");
const job_1 = require("./job");
const ticket_messages_1 = require("./ticket-messages");
var TicketStatusEnum;
(function (TicketStatusEnum) {
    TicketStatusEnum["I"] = "init";
    TicketStatusEnum["N"] = "new";
    TicketStatusEnum["T"] = "chatting";
    TicketStatusEnum["P"] = "calling";
    TicketStatusEnum["R"] = "resolved";
    TicketStatusEnum["X"] = "deleted";
    TicketStatusEnum["B"] = "spam";
    TicketStatusEnum["A"] = "answered";
    TicketStatusEnum["C"] = "open";
    TicketStatusEnum["W"] = "postponed";
    TicketStatusEnum["L"] = "closed";
})(TicketStatusEnum = exports.TicketStatusEnum || (exports.TicketStatusEnum = {}));
let Ticket = class Ticket {
};
__decorate([
    (0, typeorm_1.PrimaryColumn)(),
    __metadata("design:type", String)
], Ticket.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], Ticket.prototype, "title", void 0);
__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: TicketStatusEnum }),
    __metadata("design:type", String)
], Ticket.prototype, "status", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: '' }),
    __metadata("design:type", String)
], Ticket.prototype, "owner", void 0);
__decorate([
    (0, typeorm_1.Column)({ name: 'department_id', default: '' }),
    __metadata("design:type", String)
], Ticket.prototype, "departmentId", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => ticket_messages_1.TicketMessage, (ticketMessage) => ticketMessage.ticket),
    __metadata("design:type", Array)
], Ticket.prototype, "messages", void 0);
__decorate([
    (0, typeorm_1.ManyToMany)(() => job_1.Job, (job) => job.tickets),
    (0, typeorm_1.JoinTable)({ name: 'ticket_jobs' }),
    __metadata("design:type", Array)
], Ticket.prototype, "jobs", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp with time zone',
        name: 'created_at',
    }),
    __metadata("design:type", Date)
], Ticket.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        type: 'timestamp with time zone',
        name: 'updated_at',
    }),
    __metadata("design:type", Date)
], Ticket.prototype, "updatedAt", void 0);
Ticket = __decorate([
    data_ui_1.DataUi.Name({
        name: 'Ticket',
    }),
    (0, typeorm_1.Entity)('ticket', {
        schema: 'public',
    })
], Ticket);
exports.Ticket = Ticket;
//# sourceMappingURL=ticket.js.map